export type I18nVars = Record<string, string | number>;

/**
 * 替换文案占位符。变量值本身若是完整 i18n key，先解析成当前语言文案；
 * 普通业务字符串原样保留，缺失变量继续显示占位符，便于发现接线错误。
 */
export function interpolateMessage(
  raw: string,
  vars: I18nVars,
  resolveKey: (value: string) => string | undefined,
): string {
  return raw.replace(/\{(\w+)\}/g, (_, key: string) => {
    const value = vars[key];
    if (typeof value === "string") return resolveKey(value) ?? value;
    return value == null ? `{${key}}` : String(value);
  });
}
